import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  // Confirmed, and the title rule was right about this one: the reference
  // screenshots for this book's page came from
  // `digitopia.co/impact-labs/ebooks/top-5-ai-success-strategies/` on
  // 2026-08-28 and carry that address in their filenames.
  'top-5-ai-success-strategies',
  'Top 5 AI Success Strategies: Unlock the Full Potential of AI',
  `${UPLOADS}/2024/08/Top-5-AI-Success-Strategies-1080-x-1080-piksel-400x400.jpg`,
  {
    confirmed: true,
    // This one's PDF was known before the rest: the imported index carried it
    // as a `cta` block, which is why it reads slightly differently from the
    // fourteen marketing supplied on 2026-08-27.
    download: pdf('6b09bdf8-a5f9-432b-81c4-100ffd11e0d8-digitopia-report-top5ai-r2.pdf'),
    // Designed as its own written page on 2026-08-28, the eighth after
    // Transform Better, Agentic AI, Sustainability Innovation, Measurement,
    // AI in Fashion Retail, The Leader's Guide to Generative AI and
    // Transforming Pain into Power — so the card goes there and
    // `prerender.tsx` skips it, rather than generating the template over
    // the top of the written page.
    href: '/en/impact-labs/ebooks/top-5-ai-success-strategies',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 15
